import { Controller } from "@hotwired/stimulus"

// Category pills + search box for the restaurant menu grid.
export default class extends Controller {
  static targets = ["search", "pill", "card"]

  connect() {
    this.category = "all"
  }

  pick(event) {
    this.category = event.currentTarget.dataset.category
    this.pillTargets.forEach((pill) => {
      const active = pill === event.currentTarget
      pill.classList.toggle("btn-primary", active)
      pill.classList.toggle("btn-outline-secondary", !active)
    })
    this.filter()
  }

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()
    this.cardTargets.forEach((card) => {
      const inCategory = this.category === "all" || card.dataset.categoryId === this.category
      const matches = !query || card.dataset.search.includes(query)
      card.classList.toggle("d-none", !(inCategory && matches))
    })
  }
}
